import React from "react";
import Button from "./Button";

const isActive = (filters, type, match) => {
  if (Object.keys(filters).length === 0) {
    return false;
  }

  if (type === "delivery") {
    console.log(0, "filters", filters);
    console.log(1, "type", type);
    console.log(2, "match", match);
  }

  return filters[type] === match;
};

const categoryGenerator = (bizData, updateFilters, filters) => {
  const allCategories = bizData.map((biz) => biz.category);

  const unique = (value, index, self) => {
    return self.indexOf(value) === index;
  };

  const uniqueCats = allCategories
    .filter(unique)
    .filter((cat) => cat != null)
    .sort();

  return [
    ...uniqueCats.map((cat, index) => (
      <Button
        key={index}
        onClick={() => updateFilters({ id: "category", value: cat })}
        active={isActive(filters, "category", cat)}
      >
        {cat}
      </Button>
    )),
  ];
};

const deliveryGenerator = (updateFilters, filters) => {
  const deliveryOptions = ["Pick up", "Delivery"];

  return [
    ...deliveryOptions.map((option, index) => (
      <Button
        key={index}
        onClick={() =>
          updateFilters({
            id: "delivery",
            value: option.replace(/\W/g, "").toLowerCase(),
          })
        }
        active={isActive(
          filters,
          "delivery",
          option.replace(/\W/g, "").toLowerCase()
        )}
      >
        {option}
      </Button>
    )),
  ];
};

export { categoryGenerator, deliveryGenerator };
